export default {
    title: 'Rollen',
    name: 'Identifikator',
    name_de: 'Name',
    sort: 'Sortierung',
}